import React, { useCallback, useEffect, useMemo, useState } from "react";

const DEFAULT_API_BASE =
  "https://panel.haymestasarim.com/api/mespuan";

const EMPTY_FORM = {
  title: "",
  sponsor_name: "",
  description: "",

  duration_seconds: 30,
  completion_percent: 100,
  reward_points: 25,

  daily_view_limit: 1,
  total_view_limit: "",
  budget_points: "",

  start_at: "",
  end_at: "",

  target_type: "all",
  target_value: "",

  ad_category: "general",
  target_min_age: "",
  target_max_age: "",
  target_genders: "all",
  target_sectors: "",
  target_languages: "",

  view_credit_cost: 1,
  click_credit_cost: 0,
  showcase_bid_credits: 0,

  consent_confirmed: false,
};

const TARGET_OPTIONS = [
  { value: "all", textKey: "targetAll" },
  { value: "institution", textKey: "targetInstitution" },
  { value: "country", textKey: "targetCountry" },
  { value: "city", textKey: "targetCity" },
  { value: "district", textKey: "targetDistrict" },
  { value: "group", textKey: "targetGroup" },
  { value: "new_users", textKey: "targetNewUsers" },
];

const TEXTS = {
  tr: {
    title: "Sponsor Video Başvurusu",
    subtitle:
      "Reklam videonuzu doğrudan yükleyin. İçerik, MesYat merkez onayından önce yayınlanmaz.",
    newApplication: "Yeni Reklam Başvurusu",
    myApplications: "Başvurularım",
    campaignTitle: "Reklam başlığı",
    sponsor: "Sponsor / firma adı",
    description: "Reklam açıklaması",
    video: "Video dosyası",



    videoHelp: "MP4, WebM veya MOV · En fazla 100 MB · En fazla 60 saniye",
    thumbnail: "Kapak resmi",
    thumbnailHelp: "JPG, PNG veya WebP · En fazla 5 MB",


    chooseVideo: "Video Seç",
    chooseImage: "Kapak Seç",
    duration: "Video süresi (saniye)",
    completion: "Tamamlama oranı (%)",
    reward: "Video başına MesPuan",
    dailyLimit: "Günlük izleme hakkı",
    totalLimit: "Toplam izlenme sınırı",


      budget: "Toplam MesPuan bütçesi",

    category: "Reklam kategorisi",
    targetAudience: "Hedef kitle",
    targetValue: "Hedef değer",
    targetAll: "Herkes",
    targetInstitution: "Belirli kurum",
    targetCountry: "Belirli ülke",
    targetCity: "Belirli şehir",
    targetDistrict: "Belirli ilçe",
    targetGroup: "Belirli grup",
    targetNewUsers: "Yeni kullanıcılar",

    minimumAge: "Minimum yaş",
    maximumAge: "Maksimum yaş",
    genders: "Cinsiyet hedefleri",
    gendersHelp: "Örnek: all veya female, male",
    sectors: "Sektör hedefleri",
    sectorsHelp: "Virgülle ayırın: kuaför, restoran, eğitim",
    languages: "Dil hedefleri",
    languagesHelp: "Virgülle ayırın: tr, en, de",

    viewCredit: "İzleme kredi bedeli",
    clickCredit: "Tıklama kredi bedeli",
    showcaseBid: "Vitrin teklif kredisi",
    adCredits: "MesReklam Kredisi",

    start: "Başlangıç tarihi",
    end: "Bitiş tarihi",
    unlimited: "Boş = sınırsız",


    consent:
      "Videonun yayın haklarına sahip olduğumu ve MesYat reklam kurallarını kabul ettiğimi onaylıyorum.",
    submit: "Onaya Gönder",
    submitting: "Video yükleniyor...",
    refresh: "Yenile",
    pending: "İnceleme Bekliyor",
    approved: "Onaylandı ve Yayında",
    rejected: "Reddedildi",
    cancelled: "İptal Edildi",

       cancel: "Başvuruyu İptal Et",
    edit: "Düzenle",
    delete: "Sil",
    editingApplication:
      "Reklam Başvurusunu Düzenle",
    update:
      "Değişiklikleri Onaya Gönder",
    updating: "Güncelleniyor...",
    stopEditing:
      "Düzenlemeyi İptal Et",
    editNotice:
      "Düzenlediğiniz reklam yeniden merkez onayına gönderilir. Yayındaysa yeni onaya kadar yayından kaldırılır.",
    updatedMessage:
      "Reklam başvurusu güncellendi ve yeniden merkez onayına gönderildi.",
    deletedMessage:
      "Reklam başvurusu silindi.",
    deleteConfirm:
      "“{title}” reklam başvurusunu kalıcı olarak silmek istiyor musunuz?",
    empty:
      "Henüz reklam başvurusu bulunmuyor.",


    sent:
      "Reklam başvurunuz alındı. Merkez MesYat onayından sonra yayınlanacaktır.",
    cancelledMessage: "Reklam başvurusu iptal edildi.",
    requiredVideo: "Bir reklam videosu seçmelisiniz.",
    requiredConsent: "Yayın hakları onayını işaretlemelisiniz.",


      fileTooLarge: "Video dosyası en fazla 100 MB olabilir.",
    imageTooLarge: "Kapak resmi en fazla 5 MB olabilir.",
    invalidVideo: "Yalnızca MP4, WebM veya MOV video seçebilirsiniz.",
    invalidImage: "Kapak resmi JPG, PNG veya WebP olmalıdır.",
    invalidDuration: "Video süresi 5 ile 60 saniye arasında olmalıdır.",
    invalidAgeRange: "Maksimum yaş minimum yaştan küçük olamaz.",



    operationFailed: "İşlem tamamlanamadı.",
    reviewNote: "Yönetici notu",
    points: "MesPuan",
    views: "izlenme",
    noVideoSupport: "Tarayıcınız video oynatmayı desteklemiyor.",
  },
  en: {
    title: "Sponsor Video Application",
    subtitle:
      "Upload your advertising video directly. It will not be published before central MesYat approval.",
    newApplication: "New Advertising Application",
    myApplications: "My Applications",
    campaignTitle: "Advertising title",
    sponsor: "Sponsor / company name",
    description: "Advertising description",
    video: "Video file",


    videoHelp: "MP4, WebM or MOV · Maximum 100 MB · Maximum 60 seconds",
    thumbnail: "Cover image",
    thumbnailHelp: "JPG, PNG or WebP · Maximum 5 MB",


    chooseVideo: "Choose Video",
    chooseImage: "Choose Cover",
    duration: "Video duration (seconds)",
    completion: "Completion rate (%)",
    reward: "MesPuan per video",
    dailyLimit: "Daily viewing limit",
    totalLimit: "Total viewing limit",
      budget: "Total MesPuan budget",

    category: "Advertising category",
    targetAudience: "Target audience",
    targetValue: "Target value",
    targetAll: "Everyone",
    targetInstitution: "Specific institution",
    targetCountry: "Specific country",
    targetCity: "Specific city",
    targetDistrict: "Specific district",
    targetGroup: "Specific group",
    targetNewUsers: "New users",

    minimumAge: "Minimum age",
    maximumAge: "Maximum age",
    genders: "Gender targeting",
    gendersHelp: "Example: all or female, male",
    sectors: "Sector targeting",
    sectorsHelp: "Separate with commas: hairdresser, restaurant, education",
    languages: "Language targeting",
    languagesHelp: "Separate with commas: tr, en, de",

    viewCredit: "View credit cost",
    clickCredit: "Click credit cost",
    showcaseBid: "Showcase bid credit",
    adCredits: "MesAdvertising Credits",

    start: "Start date",
    end: "End date",
    unlimited: "Empty = unlimited",
    consent:
      "I confirm that I hold the publishing rights and accept the MesYat advertising rules.",
    submit: "Submit for Approval",
    submitting: "Uploading video...",
    refresh: "Refresh",
    pending: "Pending Review",
    approved: "Approved and Published",
    rejected: "Rejected",
    cancelled: "Cancelled",

    cancel: "Cancel Application",
    edit: "Edit",
    delete: "Delete",
    editingApplication:
      "Edit Advertising Application",
    update:
      "Submit Changes for Approval",
    updating: "Updating...",
    stopEditing: "Cancel Editing",
    editNotice:
      "The edited advertisement will be submitted for central approval again. If it is live, it will be unpublished until approval.",
    updatedMessage:
      "The advertising application was updated and submitted for central approval again.",
    deletedMessage:
      "The advertising application was deleted.",
    deleteConfirm:
      "Do you want to permanently delete the advertising application “{title}”?",
    empty:
      "No advertising application has been submitted yet.",

    sent:
      "Your application was received. It will be published after central MesYat approval.",
    cancelledMessage: "Advertising application cancelled.",
    requiredVideo: "You must select an advertising video.",
    requiredConsent: "You must confirm the publishing rights.",
      fileTooLarge: "The video file may be at most 100 MB.",
    imageTooLarge: "The cover image may be at most 5 MB.",
    invalidVideo: "Only MP4, WebM or MOV videos are accepted.",
    invalidImage: "The cover image must be JPG, PNG or WebP.",
    invalidDuration: "Video duration must be between 5 and 60 seconds.",
    invalidAgeRange: "Maximum age cannot be lower than minimum age.",
    operationFailed: "The operation could not be completed.",
    reviewNote: "Administrator note",
    points: "MesPuan",
    views: "views",
    noVideoSupport: "Your browser does not support video playback.",
  },
  de: {
    title: "Sponsorvideo-Antrag",
    subtitle:
      "Laden Sie Ihr Werbevideo direkt hoch. Vor der zentralen MesYat-Freigabe wird es nicht veröffentlicht.",
    newApplication: "Neuer Werbeantrag",
    myApplications: "Meine Anträge",
    campaignTitle: "Werbetitel",
    sponsor: "Sponsor / Firmenname",
    description: "Werbebeschreibung",
    video: "Videodatei",
      videoHelp: "MP4, WebM oder MOV · Maximal 100 MB · Maximal 60 Sekunden",
    thumbnail: "Titelbild",
    thumbnailHelp: "JPG, PNG oder WebP · Maximal 5 MB",
    chooseVideo: "Video auswählen",
    chooseImage: "Titelbild auswählen",
    duration: "Videodauer (Sekunden)",
    completion: "Abschlussrate (%)",
    reward: "MesPuan pro Video",
    dailyLimit: "Tägliches Ansichtslimit",
    totalLimit: "Gesamtes Ansichtslimit",


    budget: "Gesamtes MesPuan-Budget",

    category: "Werbekategorie",
    targetAudience: "Zielgruppe",
    targetValue: "Zielwert",
    targetAll: "Alle",
    targetInstitution: "Bestimmte Institution",
    targetCountry: "Bestimmtes Land",
    targetCity: "Bestimmte Stadt",
    targetDistrict: "Bestimmter Bezirk",
    targetGroup: "Bestimmte Gruppe",
    targetNewUsers: "Neue Benutzer",

    minimumAge: "Mindestalter",
    maximumAge: "Höchstalter",
    genders: "Geschlechtsausrichtung",
    gendersHelp: "Beispiel: all oder female, male",
    sectors: "Branchenausrichtung",
    sectorsHelp: "Mit Komma trennen: Friseur, Restaurant, Bildung",
    languages: "Sprachausrichtung",
    languagesHelp: "Mit Komma trennen: tr, en, de",

    viewCredit: "Kosten pro Ansicht",
    clickCredit: "Kosten pro Klick",
    showcaseBid: "Schaufenster-Gebot",
    adCredits: "MesWerbekredite",

    start: "Startdatum",
    end: "Enddatum",
    unlimited: "Leer = unbegrenzt",

    consent:
      "Ich bestätige, dass ich die Veröffentlichungsrechte besitze und die MesYat-Werberegeln akzeptiere.",
    submit: "Zur Freigabe senden",
    submitting: "Video wird hochgeladen...",
    refresh: "Aktualisieren",
    pending: "Prüfung ausstehend",
    approved: "Genehmigt und veröffentlicht",
    rejected: "Abgelehnt",
    cancelled: "Storniert",
    cancel: "Antrag stornieren",
    edit: "Bearbeiten",
    delete: "Löschen",
    editingApplication:
      "Werbeantrag bearbeiten",
    update:
      "Änderungen zur Freigabe senden",
    updating: "Wird aktualisiert...",
    stopEditing:
      "Bearbeitung abbrechen",
    editNotice:
      "Die bearbeitete Werbung wird erneut zur zentralen Freigabe gesendet. Eine veröffentlichte Werbung wird bis zur neuen Freigabe deaktiviert.",
    updatedMessage:
      "Der Werbeantrag wurde aktualisiert und erneut zur zentralen Freigabe gesendet.",
    deletedMessage:
      "Der Werbeantrag wurde gelöscht.",
    deleteConfirm:
      "Möchten Sie den Werbeantrag „{title}“ dauerhaft löschen?",
    empty:
      "Noch kein Werbeantrag vorhanden.",

    sent:
      "Ihr Antrag wurde empfangen. Er wird nach der zentralen MesYat-Freigabe veröffentlicht.",
    cancelledMessage: "Werbeantrag storniert.",
    requiredVideo: "Sie müssen ein Werbevideo auswählen.",
    requiredConsent: "Sie müssen die Veröffentlichungsrechte bestätigen.",


     fileTooLarge: "Die Videodatei darf maximal 100 MB groß sein.",
    imageTooLarge: "Das Titelbild darf maximal 5 MB groß sein.",
    invalidVideo: "Nur MP4-, WebM- oder MOV-Videos sind erlaubt.",
    invalidImage: "Das Titelbild muss JPG, PNG oder WebP sein.",
    invalidDuration: "Die Videodauer muss zwischen 5 und 60 Sekunden liegen.",
    invalidAgeRange: "Das Höchstalter darf nicht unter dem Mindestalter liegen.",


    operationFailed: "Der Vorgang konnte nicht abgeschlossen werden.",
    reviewNote: "Administratornotiz",
    points: "MesPuan",
    views: "Ansichten",
    noVideoSupport:
      "Ihr Browser unterstützt die Videowiedergabe nicht.",
  },
};

function copyFor(language) {
  return TEXTS[language] || TEXTS.tr;
}

async function readPayload(response) {
  const raw = await response.text();
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return { message: raw };
  }
}

function listFrom(payload) {
  if (Array.isArray(payload?.data?.items)) return payload.data.items;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

function publicUrl(value, apiBase) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  try {
    const origin = new URL(apiBase).origin;
    return `${origin}/${raw.replace(/^\/+/, "")}`;
  } catch {
    return raw;
  }
}

function listInputValue(
  value,
  fallback = ""
) {
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  const raw =
    String(value || "").trim();

  return raw || fallback;
}

function dateTimeInputValue(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const localDate = new Date(
    date.getTime() -
      date.getTimezoneOffset() *
        60 *
        1000
  );

  return localDate
    .toISOString()
    .slice(0, 16);
}

function statusText(status, copy) {
  return copy[status] || status;
}
function statusClass(status) {
  return `mpr-status status-${status || "pending"}`;
}

function Field({ label, help, wide, children }) {
  return (
    <label className={`mpr-field${wide ? " is-wide" : ""}`}>
      <span>{label}</span>
      {children}
      {help && <small>{help}</small>}
    </label>
  );
}

export default function MespuanReklamBasvuru({
  token,
  language = "tr",
  apiBase = DEFAULT_API_BASE,
}) {
  const copy = useMemo(() => copyFor(language), [language]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [video, setVideo] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");


  const [
    thumbnailPreview,
    setThumbnailPreview,
  ] = useState("");

  const [
    editingItem,
    setEditingItem,
  ] = useState(null);

  const [items, setItems] = useState([]);


  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [notice, setNotice] = useState(null);

  const loadApplications = useCallback(async () => {
    if (!token) return;
    setListLoading(true);
    try {
      const response = await fetch(`${apiBase}/reklam/my`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const payload = await readPayload(response);
      if (!response.ok) {
        throw new Error(payload?.message || copy.operationFailed);
      }
      setItems(listFrom(payload));
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    } finally {
      setListLoading(false);
    }
  }, [apiBase, copy.operationFailed, token]);

  useEffect(() => {
    loadApplications();
  }, [loadApplications]);

  useEffect(
    () => () => {
      if (videoPreview) URL.revokeObjectURL(videoPreview);
      if (thumbnailPreview) URL.revokeObjectURL(thumbnailPreview);
    },
    [thumbnailPreview, videoPreview]
  );



  function update(key, value) {
    setForm((current) => ({
      ...current,
      [key]: value,
    }));
  }

  function resetEditor() {
    setEditingItem(null);
    setForm({ ...EMPTY_FORM });
    setVideo(null);
    setThumbnail(null);

    if (videoPreview) {
      URL.revokeObjectURL(
        videoPreview
      );
    }

    if (thumbnailPreview) {
      URL.revokeObjectURL(
        thumbnailPreview
      );
    }

    setVideoPreview("");
    setThumbnailPreview("");
  }

  function startEdit(item) {
    setEditingItem(item);

    setForm({
      title:
        item.title || "",

      sponsor_name:
        item.sponsor_name || "",

      description:
        item.description || "",

      duration_seconds:
        item.duration_seconds || 30,

      completion_percent:
        item.completion_percent || 100,

      reward_points:
        item.reward_points || 25,

      daily_view_limit:
        item.daily_view_limit || 1,

      total_view_limit:
        item.total_view_limit || "",

      budget_points:
        item.budget_points || "",

      start_at:
        dateTimeInputValue(
          item.start_at
        ),

      end_at:
        dateTimeInputValue(
          item.end_at
        ),

      target_type:
        item.target_type || "all",

      target_value:
        item.target_value || "",

      ad_category:
        item.ad_category || "general",

      target_min_age:
        item.target_min_age || "",

      target_max_age:
        item.target_max_age || "",

      target_genders:
        listInputValue(
          item.target_genders,
          "all"
        ),

      target_sectors:
        listInputValue(
          item.target_sectors
        ),

      target_languages:
        listInputValue(
          item.target_languages
        ),

      view_credit_cost:
        item.view_credit_cost ?? 1,

      click_credit_cost:
        item.click_credit_cost ?? 0,

      showcase_bid_credits:
        item.showcase_bid_credits ?? 0,

      consent_confirmed:
        Boolean(
          item.consent_confirmed
        ),
    });

    setVideo(null);
    setThumbnail(null);

    setVideoPreview(
      publicUrl(
        item.video_url,
        apiBase
      )
    );

    setThumbnailPreview(
      publicUrl(
        item.thumbnail_url,
        apiBase
      )
    );

    setNotice(null);

    window.setTimeout(() => {
      document
        .querySelector(
          ".mpr-form-panel"
        )
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 50);
  }

  function chooseVideo(file) {


    if (!file) return;

    const allowedTypes = new Set([
      "video/mp4",
      "video/webm",
      "video/quicktime",
    ]);

    const extension = file.name
      .split(".")
      .pop()
      ?.toLowerCase();

    if (
      !allowedTypes.has(file.type) ||
      !["mp4", "webm", "mov"].includes(extension)
    ) {
      setNotice({
        type: "error",
        text: copy.invalidVideo,
      });
      return;
    }

    if (file.size > 100 * 1024 * 1024) {
      setNotice({
        type: "error",
        text: copy.fileTooLarge,
      });
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    const metadataReader = document.createElement("video");

    metadataReader.preload = "metadata";

    metadataReader.onloadedmetadata = () => {
      const actualDuration = Math.ceil(
        Number(metadataReader.duration || 0)
      );

      if (
        !Number.isFinite(actualDuration) ||
        actualDuration < 5 ||
        actualDuration > 60
      ) {
        URL.revokeObjectURL(previewUrl);

        setNotice({
          type: "error",
          text: copy.invalidDuration,
        });

        return;
      }

      if (videoPreview) {
        URL.revokeObjectURL(videoPreview);
      }

      setVideo(file);
      setVideoPreview(previewUrl);

      setForm((current) => ({
        ...current,
        duration_seconds: actualDuration,
      }));

      setNotice(null);
    };

    metadataReader.onerror = () => {
      URL.revokeObjectURL(previewUrl);

      setNotice({
        type: "error",
        text: copy.invalidVideo,
      });
    };

    metadataReader.src = previewUrl;
  }



  function chooseThumbnail(file) {
    if (!file) return;
    const allowedTypes = new Set([
      "image/jpeg",
      "image/png",
      "image/webp",
    ]);
    if (!allowedTypes.has(file.type)) {
      setNotice({ type: "error", text: copy.invalidImage });
      return;
    }
       if (file.size > 5 * 1024 * 1024) {
      setNotice({
        type: "error",
        text: copy.imageTooLarge,
      });
      return;
    }


    if (thumbnailPreview) URL.revokeObjectURL(thumbnailPreview);
    setThumbnail(file);
    setThumbnailPreview(URL.createObjectURL(file));
    setNotice(null);
  }



  async function submit(event) {
    event.preventDefault();

    if (
      !video &&
      !editingItem?.video_url
    ) {
      setNotice({
        type: "error",
        text: copy.requiredVideo,
      });

      return;
    }

    if (!form.consent_confirmed) {
      setNotice({
        type: "error",
        text: copy.requiredConsent,
      });

      return;
    }

    const duration =
      Number(
        form.duration_seconds
      );

    if (
      !Number.isFinite(duration) ||
      duration < 5 ||
      duration > 60
    ) {
      setNotice({
        type: "error",
        text: copy.invalidDuration,
      });

      return;
    }

    const minimumAge =
      form.target_min_age === ""
        ? null
        : Number(
            form.target_min_age
          );

    const maximumAge =
      form.target_max_age === ""
        ? null
        : Number(
            form.target_max_age
          );

    if (
      minimumAge !== null &&
      maximumAge !== null &&
      maximumAge < minimumAge
    ) {
      setNotice({
        type: "error",
        text: copy.invalidAgeRange,
      });

      return;
    }

    const normalizeList = (
      value,
      fallback = []
    ) => {
      const values =
        String(value || "")
          .split(",")
          .map(
            (item) =>
              item.trim()
          )
          .filter(Boolean);

      return values.length > 0
        ? [...new Set(values)]
        : fallback;
    };

    const payload = {
      ...form,

      target_value:
        form.target_type === "all"
          ? ""
          : form.target_value,

      target_genders:
        JSON.stringify(
          normalizeList(
            form.target_genders,
            ["all"]
          )
        ),

      target_sectors:
        JSON.stringify(
          normalizeList(
            form.target_sectors
          )
        ),

      target_languages:
        JSON.stringify(
          normalizeList(
            form.target_languages
          ).map(
            (languageCode) =>
              languageCode
                .toLowerCase()
                .split(/[-_]/)[0]
          )
        ),
    };

    const data =
      new FormData();

    if (video) {
      data.append(
        "video",
        video
      );
    }

    if (thumbnail) {
      data.append(
        "thumbnail",
        thumbnail
      );
    }

    Object.entries(payload).forEach(
      ([key, value]) => {
        if (
          value !== "" &&
          value !== null &&
          value !== undefined
        ) {
          data.append(
            key,
            String(value)
          );
        }
      }
    );

    setLoading(true);
    setNotice(null);

    try {
      const response =
        await fetch(
          editingItem
            ? `${apiBase}/reklam/my/${editingItem.id}`
            : `${apiBase}/reklam/submit`,
          {
            method:
              editingItem
                ? "PATCH"
                : "POST",

            headers: {
              Authorization:
                `Bearer ${token}`,

              Accept:
                "application/json",
            },

            body: data,
          }
        );

      const responsePayload =
        await readPayload(
          response
        );

      if (!response.ok) {
        throw new Error(
          responsePayload?.message ||
            copy.operationFailed
        );
      }

      const successText =
        editingItem
          ? copy.updatedMessage
          : copy.sent;

      resetEditor();

      setNotice({
        type: "success",
        text:
          responsePayload?.message ||
          successText,
      });

      await loadApplications();
    } catch (error) {
      setNotice({
        type: "error",
        text: error.message,
      });


    } finally {
      setLoading(false);
    }
  }

  async function cancel(item) {
    if (
      !window.confirm(
        `${item.title}: ${copy.cancel}?`
      )
    ) {
      return;
    }

    try {
      const response =
        await fetch(
          `${apiBase}/reklam/my/${item.id}/cancel`,
          {
            method: "PATCH",
            headers: {
              Authorization:
                `Bearer ${token}`,

              Accept:
                "application/json",
            },
          }
        );

      const payload =
        await readPayload(response);

      if (!response.ok) {
        throw new Error(
          payload?.message ||
            copy.operationFailed
        );
      }

      setNotice({
        type: "success",
        text:
          payload?.message ||
          copy.cancelledMessage,
      });

      await loadApplications();
    } catch (error) {
      setNotice({
        type: "error",
        text: error.message,
      });
    }
  }

  async function deleteApplication(
    item
  ) {
    const confirmText =
      copy.deleteConfirm.replace(
        "{title}",
        item.title || ""
      );

    if (
      !window.confirm(
        confirmText
      )
    ) {
      return;
    }

    try {
      const response =
        await fetch(
          `${apiBase}/reklam/my/${item.id}`,
          {
            method: "DELETE",
            headers: {
              Authorization:
                `Bearer ${token}`,

              Accept:
                "application/json",
            },
          }
        );

      const payload =
        await readPayload(response);

      if (!response.ok) {
        throw new Error(
          payload?.message ||
            copy.operationFailed
        );
      }

      if (
        editingItem?.id ===
        item.id
      ) {
        resetEditor();
      }

      setNotice({
        type: "success",
        text:
          payload?.message ||
          copy.deletedMessage,
      });

      await loadApplications();
    } catch (error) {
      setNotice({
        type: "error",
        text: error.message,
      });
    }
  }


  return (
    <div className="mpr-page">
      <style>{STYLES}</style>

      <header className="mpr-header">
        <div>
          <span>MESYAT / MESPUAN</span>
          <h2>{copy.title}</h2>
          <p>{copy.subtitle}</p>
        </div>
      </header>

      {notice && (
        <div className={`mpr-notice is-${notice.type}`}>{notice.text}</div>
      )}


      <section className="mpr-panel mpr-form-panel">
        <h3>
          {editingItem
            ? copy.editingApplication
            : copy.newApplication}
        </h3>

        {editingItem && (
          <div className="mpr-edit-notice">
            {copy.editNotice}
          </div>
        )}

        <form onSubmit={submit}>

          <div className="mpr-form-grid">
            <Field label={copy.campaignTitle} wide>
              <input
                required
                maxLength={180}
                value={form.title}
                onChange={(event) => update("title", event.target.value)}
              />
            </Field>
            <Field label={copy.sponsor}>
              <input
                maxLength={180}
                value={form.sponsor_name}
                onChange={(event) =>
                  update("sponsor_name", event.target.value)
                }
              />
            </Field>


                   <Field
              label={copy.duration}
              help={copy.invalidDuration}
            >
              <input
                type="number"
                min="5"
                max="60"
                required
                value={form.duration_seconds}
                onChange={(event) =>
                  update(
                    "duration_seconds",
                    event.target.value
                  )
                }
              />
            </Field>



            <Field label={copy.description} wide>
              <textarea
                rows={3}
                maxLength={3000}
                value={form.description}
                onChange={(event) =>
                  update("description", event.target.value)
                }
              />
            </Field>

            <Field label={copy.video} help={copy.videoHelp} wide>
              <label className="mpr-upload">
                <b>{copy.chooseVideo}</b>
<span>
  {video?.name ||
    editingItem?.video_original_name ||
    copy.videoHelp}
</span>

                <input
                  type="file"
                  accept="video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov"
                  onChange={(event) => chooseVideo(event.target.files?.[0])}
                />
              </label>
              {videoPreview && (
                <video
                  className="mpr-video-preview"
                  controls
                  preload="metadata"
                  src={videoPreview}
                >
                  {copy.noVideoSupport}
                </video>
              )}
            </Field>

            <Field label={copy.thumbnail} help={copy.thumbnailHelp} wide>
              <label className="mpr-upload is-image">
                <b>{copy.chooseImage}</b>
<span>
  {thumbnail?.name ||
    (editingItem?.thumbnail_url
      ? copy.thumbnail
      : copy.thumbnailHelp)}
</span>

                <input
                  type="file"
                  accept="image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp"
                  onChange={(event) =>
                    chooseThumbnail(event.target.files?.[0])
                  }
                />
              </label>
              {thumbnailPreview && (
                <img
                  className="mpr-image-preview"
                  src={thumbnailPreview}
                  alt={copy.thumbnail}
                />
              )}
            </Field>

            <Field label={copy.completion}>
              <input
                type="number"
                min="90"
                max="100"
                required
                value={form.completion_percent}
                onChange={(event) =>
                  update("completion_percent", event.target.value)
                }
              />
            </Field>
            <Field label={copy.reward}>
              <input
                type="number"
                min="1"
                required
                value={form.reward_points}
                onChange={(event) =>
                  update("reward_points", event.target.value)
                }
              />
            </Field>
            <Field label={copy.dailyLimit}>
              <input
                type="number"
                min="1"
                value={form.daily_view_limit}
                onChange={(event) =>
                  update("daily_view_limit", event.target.value)
                }
              />
            </Field>
            <Field label={copy.totalLimit}>
              <input
                type="number"
                min="1"
                placeholder={copy.unlimited}
                value={form.total_view_limit}
                onChange={(event) =>
                  update("total_view_limit", event.target.value)
                }
              />
            </Field>


            <Field label={copy.budget}>
              <input
                type="number"
                min="1"
                placeholder={copy.unlimited}
                value={form.budget_points}
                onChange={(event) =>
                  update(
                    "budget_points",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={copy.category}>
              <input
                maxLength={80}
                value={form.ad_category}
                onChange={(event) =>
                  update(
                    "ad_category",
                    event.target.value
                  )
                }
                placeholder="general"
              />
            </Field>

            <Field label={copy.targetAudience}>
              <select
                value={form.target_type}
                onChange={(event) => {
                  const nextTarget =
                    event.target.value;

                  setForm((current) => ({
                    ...current,
                    target_type: nextTarget,
                    target_value:
                      nextTarget === "all"
                        ? ""
                        : current.target_value,
                  }));
                }}
              >
                {TARGET_OPTIONS.map((target) => (
                  <option
                    key={target.value}
                    value={target.value}
                  >
                    {copy[target.textKey]}
                  </option>
                ))}
              </select>
            </Field>

            {form.target_type !== "all" && (
              <Field label={copy.targetValue}>
                <input
                  maxLength={180}
                  value={form.target_value}
                  onChange={(event) =>
                    update(
                      "target_value",
                      event.target.value
                    )
                  }
                />
              </Field>
            )}

            <Field label={copy.minimumAge}>
              <input
                type="number"
                min="13"
                max="100"
                value={form.target_min_age}
                onChange={(event) =>
                  update(
                    "target_min_age",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={copy.maximumAge}>
              <input
                type="number"
                min="13"
                max="100"
                value={form.target_max_age}
                onChange={(event) =>
                  update(
                    "target_max_age",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field
              label={copy.genders}
              help={copy.gendersHelp}
              wide
            >
              <input
                value={form.target_genders}
                onChange={(event) =>
                  update(
                    "target_genders",
                    event.target.value
                  )
                }
                placeholder="all"
              />
            </Field>

            <Field
              label={copy.sectors}
              help={copy.sectorsHelp}
              wide
            >
              <input
                value={form.target_sectors}
                onChange={(event) =>
                  update(
                    "target_sectors",
                    event.target.value
                  )
                }
                placeholder="kuaför, restoran, eğitim"
              />
            </Field>

            <Field
              label={copy.languages}
              help={copy.languagesHelp}
              wide
            >
              <input
                value={form.target_languages}
                onChange={(event) =>
                  update(
                    "target_languages",
                    event.target.value
                  )
                }
                placeholder="tr, en, de"
              />
            </Field>

            <Field label={copy.viewCredit}>
              <input
                type="number"
                min="0"
                step="1"
                value={form.view_credit_cost}
                onChange={(event) =>
                  update(
                    "view_credit_cost",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={copy.clickCredit}>
              <input
                type="number"
                min="0"
                step="1"
                value={form.click_credit_cost}
                onChange={(event) =>
                  update(
                    "click_credit_cost",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={copy.showcaseBid}>
              <input
                type="number"
                min="0"
                step="1"
                value={form.showcase_bid_credits}
                onChange={(event) =>
                  update(
                    "showcase_bid_credits",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={copy.start}>

              <input
                type="datetime-local"
                value={form.start_at}
                onChange={(event) => update("start_at", event.target.value)}
              />
            </Field>
            <Field label={copy.end}>
              <input
                type="datetime-local"
                value={form.end_at}
                onChange={(event) => update("end_at", event.target.value)}
              />
            </Field>
          </div>

          <label className="mpr-consent">
            <input
              type="checkbox"
              checked={form.consent_confirmed}
              onChange={(event) =>
                update("consent_confirmed", event.target.checked)
              }
            />
            <span>{copy.consent}</span>
          </label>




          <div className="mpr-form-footer">
            {editingItem && (
              <button
                type="button"
                className="is-secondary"
                onClick={resetEditor}
                disabled={loading}
              >
                {copy.stopEditing}
              </button>
            )}

            <button
              type="submit"
              disabled={loading}
            >
              {loading
                ? editingItem
                  ? copy.updating
                  : copy.submitting
                : editingItem
                  ? copy.update
                  : copy.submit}
            </button>
          </div>


        </form>
      </section>

      <section className="mpr-panel">
        <div className="mpr-section-title">
          <h3>{copy.myApplications}</h3>
          <button
            type="button"
            className="is-light"
            onClick={loadApplications}
            disabled={listLoading}
          >
            {copy.refresh}
          </button>
        </div>

        {items.length === 0 ? (
          <div className="mpr-empty">{copy.empty}</div>
        ) : (
          <div className="mpr-list">
            {items.map((item) => (
              <article className="mpr-card" key={item.id}>
                <div className="mpr-card-media">
                  <video
                    controls
                    preload="metadata"
                    poster={
                      publicUrl(item.thumbnail_url, apiBase) || undefined
                    }
                    src={publicUrl(item.video_url, apiBase)}
                  >
                    {copy.noVideoSupport}
                  </video>
                </div>
                <div className="mpr-card-body">
                  <div className="mpr-card-title">
                    <div>
                      <strong>{item.title}</strong>
                      <span>{item.sponsor_name || "MesYat"}</span>
                    </div>
                    <span className={statusClass(item.status)}>
                      {statusText(item.status, copy)}
                    </span>
                  </div>



                  <div className="mpr-card-stats">
                    <span>
                      <b>{item.reward_points}</b>
                      {copy.points}
                    </span>

                    <span>
                      <b>{item.daily_view_limit}</b>
                      / gün
                    </span>

                    <span>
                      <b>{item.total_view_limit || "∞"}</b>
                      {copy.views}
                    </span>

                    <span>
                      <b>{item.view_credit_cost || 0}</b>
                      {copy.viewCredit}
                    </span>

                    <span>
                      <b>{item.click_credit_cost || 0}</b>
                      {copy.clickCredit}
                    </span>

                    <span>
                      <b>{item.showcase_bid_credits || 0}</b>
                      {copy.showcaseBid}
                    </span>
                  </div>

                  <div className="mpr-target-summary">
                    <span>
                      {copy.category}:{" "}
                      <b>{item.ad_category || "general"}</b>
                    </span>

                    <span>
                      {copy.targetAudience}:{" "}
                      <b>
                        {copy[
                          TARGET_OPTIONS.find(
                            (target) =>
                              target.value ===
                              item.target_type
                          )?.textKey
                        ] ||
                          item.target_type ||
                          copy.targetAll}
                      </b>
                    </span>
                  </div>

                  {item.review_note && (
                    <div className="mpr-review-note">
                      <b>{copy.reviewNote}:</b> {item.review_note}
                    </div>
                  )}



                  <div className="mpr-card-actions">
                    <button
                      type="button"
                      className="mpr-edit"
                      onClick={() =>
                        startEdit(item)
                      }
                    >
                      {copy.edit}
                    </button>

                    {item.status === "pending" && (
                      <button
                        type="button"
                        className="mpr-cancel"
                        onClick={() =>
                          cancel(item)
                        }
                      >
                        {copy.cancel}
                      </button>
                    )}

                    <button
                      type="button"
                      className="mpr-delete"
                      onClick={() =>
                        deleteApplication(
                          item
                        )
                      }
                    >
                      {copy.delete}
                    </button>
                  </div>


                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

const STYLES = `
  .mpr-page {
    --mpr-blue: #0b4d8b;
    --mpr-navy: #0a365f;
    --mpr-orange: #f58220;
    --mpr-ink: #132238;
    --mpr-muted: #64748b;
    --mpr-border: #dce6ef;
    display: grid;
    gap: 15px;
    color: var(--mpr-ink);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, sans-serif;
  }
  .mpr-page * { box-sizing: border-box; }
  .mpr-header {
    padding: 20px;
    border-radius: 19px;
    color: #fff;
    background: linear-gradient(120deg, var(--mpr-navy), var(--mpr-blue));
  }
  .mpr-header span { color: #ffbd85; font-size: 10px; font-weight: 900; letter-spacing: .9px; }
  .mpr-header h2 { margin: 5px 0; font-size: 23px; }
  .mpr-header p { max-width: 720px; margin: 0; color: #dceaf6; font-size: 12px; line-height: 1.55; }
  .mpr-panel {
    padding: 18px;
    border: 1px solid var(--mpr-border);
    border-radius: 19px;
    background: #fff;
    box-shadow: 0 9px 28px rgba(10,54,95,.07);
  }
  .mpr-panel > h3, .mpr-section-title h3 { margin: 0 0 15px; font-size: 15px; }
  .mpr-form-grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; }
  .mpr-field { display: grid; gap: 6px; }
  .mpr-field.is-wide { grid-column: 1/-1; }
  .mpr-field > span { color: #52647a; font-size: 10px; font-weight: 850; }
  .mpr-field small { color: var(--mpr-muted); font-size: 9px; }



  .mpr-field input,
  .mpr-field textarea,
  .mpr-field select {
    width: 100%;
    border: 1px solid var(--mpr-border);
    border-radius: 10px;
    padding: 10px 11px;
    color: var(--mpr-ink);
    background: #fff;
    outline: none;
  }

  .mpr-field input,
  .mpr-field select {
    height: 42px;
  }

  .mpr-field textarea {
    resize: vertical;
  }

  .mpr-field input:focus,
  .mpr-field textarea:focus,
  .mpr-field select:focus {
    border-color: #75a8d4;
    box-shadow: 0 0 0 3px rgba(11,77,139,.08);
  }


  .mpr-upload {
    min-height: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 12px;
    border: 1px dashed #75a8d4;
    border-radius: 13px;
    color: var(--mpr-blue);
    background: #f3f8fc;
    cursor: pointer;
    text-align: center;
  }
  .mpr-upload.is-image { border-color: #f1a15d; background: #fff8f1; color: #a94c08; }
  .mpr-upload b { font-size: 11px; }
  .mpr-upload span { color: var(--mpr-muted); font-size: 9px; overflow-wrap: anywhere; }
  .mpr-upload input { display: none; }
  .mpr-video-preview { width: 100%; max-height: 360px; border-radius: 14px; background: #071827; }
  .mpr-image-preview { display: block; max-width: 100%; max-height: 190px; border-radius: 13px; object-fit: cover; }
  .mpr-consent {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #cfe0f3;
    border-radius: 12px;
    color: #31465e;
    background: #f5f9fd;
    font-size: 10px;
    font-weight: 750;
    line-height: 1.5;
  }
  .mpr-consent input { margin-top: 2px; }


  .mpr-form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 14px;
  }



  .mpr-form-footer button, .mpr-section-title button {
    min-height: 41px;
    padding: 0 16px;
    border: 0;
    border-radius: 10px;
    color: #fff;
    background: linear-gradient(100deg,var(--mpr-blue),#1678c8);
    font-size: 10px;
    font-weight: 900;
    cursor: pointer;
  }

  .mpr-form-footer button.is-secondary {
    color: var(--mpr-blue);
    border: 1px solid #bed4e8;
    background: #eef5fb;
  }

  .mpr-form-footer button:disabled {
    opacity: .55;
  }

  .mpr-edit-notice {
    margin: -4px 0 14px;
    padding: 11px 12px;
    border: 1px solid #fed7aa;
    border-radius: 11px;
    color: #9a3412;
    background: #fff7ed;
    font-size: 10px;
    font-weight: 800;
    line-height: 1.5;
  }

  .mpr-notice {
    padding: 12px 14px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 800;
  }
  .mpr-notice.is-success { color: #166534; background: #dcfce7; border: 1px solid #86efac; }
  .mpr-notice.is-error { color: #991b1b; background: #fee2e2; border: 1px solid #fecaca; }
  .mpr-section-title { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 14px; }
  .mpr-section-title h3 { margin: 0; }
  .mpr-section-title button.is-light { color: var(--mpr-blue); background: #eef5fb; }
  .mpr-list { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 13px; }
  .mpr-card { overflow: hidden; border: 1px solid var(--mpr-border); border-radius: 16px; background: #fff; }
  .mpr-card-media video { display: block; width: 100%; height: 210px; object-fit: cover; background: #071827; }
  .mpr-card-body { padding: 13px; }
  .mpr-card-title { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
  .mpr-card-title strong { display: block; font-size: 12px; }
  .mpr-card-title > div span { display: block; color: var(--mpr-muted); font-size: 9px; margin-top: 3px; }
  .mpr-status { display: inline-flex; padding: 5px 8px; border-radius: 999px; font-size: 8px; font-weight: 900; white-space: nowrap; }
  .status-pending { color: #92400e; background: #fef3c7; }
  .status-approved { color: #166534; background: #dcfce7; }
  .status-rejected { color: #991b1b; background: #fee2e2; }
  .status-cancelled { color: #475569; background: #e2e8f0; }


  .mpr-card-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    margin-top: 12px;
  }

  .mpr-card-stats span {
    padding: 8px;
    border-radius: 9px;
    color: var(--mpr-muted);
    background: #f4f7fa;
    font-size: 8px;
    text-align: center;
  }

  .mpr-card-stats b {
    display: block;
    margin-bottom: 2px;
    color: var(--mpr-ink);
    font-size: 10px;
  }

  .mpr-target-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }

  .mpr-target-summary span {
    padding: 6px 8px;
    border: 1px solid #d9e6f1;
    border-radius: 999px;
    color: #52647a;
    background: #f7fafc;
    font-size: 8px;
  }

  .mpr-target-summary b {
    color: var(--mpr-ink);
  }



  .mpr-review-note {
    margin-top: 11px;
    padding: 10px;
    border-radius: 10px;
    color: #334155;
    background: #f1f5f9;
    font-size: 9px;
    line-height: 1.5;
  }

  .mpr-card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-top: 11px;
  }

  .mpr-card-actions button {
    padding: 8px 10px;
    border-radius: 9px;
    font-size: 9px;
    font-weight: 850;
    cursor: pointer;
  }

  .mpr-edit {
    border: 1px solid #bfdbfe;
    color: #075985;
    background: #eff6ff;
  }

  .mpr-cancel {
    border: 1px solid #fde68a;
    color: #92400e;
    background: #fffbeb;
  }

  .mpr-delete {
    border: 1px solid #fecaca;
    color: #b91c1c;
    background: #fff1f2;
  }


  .mpr-empty { padding: 28px; border-radius: 13px; color: var(--mpr-muted); background: #f5f8fb; text-align: center; font-size: 10px; }
  @media (max-width: 760px) {
    .mpr-form-grid, .mpr-list { grid-template-columns: 1fr; }
    .mpr-field.is-wide { grid-column: auto; }
    .mpr-form-footer {
      flex-direction: column-reverse;
    }

    .mpr-form-footer button {
      width: 100%;
    }

    .mpr-card-media video { height: auto; max-height: 280px; }
  }
`;
